<template>
  <div class="data_read_only" v-if="course">
    <div class="img">
      <img :src="course.cover" alt="">
    </div>
    <div class="content">
      <h2 class="title">{{course.title}}</h2>
      <p class="sub_title"></p>
      <div v-if="course.expectStartTime">
        <p>
          <span>日期：{{course.expectStartTime | Date('{y}-{m}-{d}')}}</span>
        </p>
        <p>
          <span>时间：</span>
          <span>{{course.expectStartTime | Date('{h}:{i}')}}</span>
          <span> - {{(course.expectStartTime + course.expectTime) | Date('{h}:{i}')}}</span>
        </p>
      </div>
      <p>主讲人：{{course.lecturerName || course.publisherName}}</p>
      <p class="description">{{course.info || course.description}}</p>
    </div>
    <div class="btn">
      <VuiButton size="large" type="warning" round @click.native="jumpToDetail">跳转课程详情</VuiButton>
    </div>
  </div>
</template>
<script>
import storage from '@/plugins/storage'
export default {
  data () {
    return {
      course: null,
      routeName: '',
      courseId: '',
      token: storage.get('token'),
      from: '',
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.routeName = this.$route.name
      this.courseId = this.$route.params.courseId
      this.from = this.$route.query.from
      if (this.routeName === 'LiveReadOnly') {
        this.getLive(this.courseId)
        storage.set('cacheUrl', `/detail/${this.courseId}?from=${this.from}`)
      } else if (this.routeName === 'RecordReadOnly') {
        this.getRecord(this.courseId)
        storage.set('cacheUrl', `/record/detail/${this.courseId}?from=${this.from}`)
      }
    },
    async getLive (courseId) {
      this.course = await this.$store.dispatch('course/getCourseData', { courseId })
    },
    async getRecord (courseId) {
      this.course = await this.$store.dispatch('course/getRecordData', { courseId })
    },
    jumpToDetail () {
      if (this.token) {
        if (this.routeName === 'LiveReadOnly') {
          this.$router.push({ name: 'LiveDetail', params: { courseId: this.courseId }, query: { from: this.from } })
        } else if (this.routeName === 'RecordReadOnly') {
          this.$router.push({ name: 'RecordDetail', params: { courseId: this.courseId }, query: { from: this.from } })
        }
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.data_read_only {
  width: 768px;
  margin: auto;
  .img {
    width: 100%;
    height: 400px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .content {
    padding: 20px 20px 80px 20px;
    .sub_title {
      color: #868688;
    }
    p {
      padding: 6px 0;
      line-height: 2;
    }
  }
  .btn {
    position: fixed;
    bottom: 10px;
    transform: translateX(-50%);
    left: 50%;
  }
}
</style>
